import { Component } from '../core/Component';
import { Vector2 } from '../core/Vector2';

/**
 * Collision shapes enumeration
 */
export enum CollisionShape {
  Circle = 'circle',
  Rectangle = 'rectangle',
  Polygon = 'polygon',
}

/**
 * Collision component for collision detection
 * Pure data component - no behavior/logic
 */
export class CollisionComponent extends Component {
  public shape: CollisionShape;
  public size: Vector2;
  public offset: Vector2;
  public isTrigger: boolean;
  public layer: string;
  public mask: string[];

  constructor(
    shape: CollisionShape = CollisionShape.Circle,
    size: Vector2 = new Vector2(32, 32),
    offset: Vector2 = new Vector2(0, 0),
    isTrigger: boolean = false,
    layer: string = 'default',
    mask: string[] = ['default']
  ) {
    super();
    this.shape = shape;
    this.size = size;
    this.offset = offset;
    this.isTrigger = isTrigger;
    this.layer = layer;
    this.mask = mask;
  }

  public clone(): CollisionComponent {
    return new CollisionComponent(
      this.shape,
      this.size.clone(),
      this.offset.clone(),
      this.isTrigger,
      this.layer,
      [...this.mask]
    );
  }
}
